export const appBaseURL = "/"

export const appCdnURL = "https://cdn.onthatass.com/nuxt/f2740e44c3a9"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"theme-color","content":"#000"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"/apple-touch-icon.webp"},{"rel":"icon","sizes":"32x32","href":"/favicon-32x32.webp"},{"rel":"icon","sizes":"16x16","href":"/favicon-16x16.webp"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com","crossorigin":"anonymous"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap","media":"print","onload":"this.media='all'"}],"style":[],"script":[{"innerHTML":"window.dataLayer = window.dataLayer || [];    function gtag() {        dataLayer.push(arguments);    }    gtag(\"consent\", \"default\", {        ad_personalization: \"denied\",        ad_storage: \"denied\",        ad_user_data: \"denied\",        analytics_storage: \"denied\",        functionality_storage: \"denied\",        personalization_storage: \"denied\",        security_storage: \"granted\",        wait_for_update: 500,    });    gtag(\"set\", \"ads_data_redaction\", true);    gtag(\"set\", \"url_passthrough\", false);","type":"text/javascript","data-cookieconsent":"ignore"},{"innerHTML":"window.dataLayer = window.dataLayer || [];","type":"text/javascript"},{"id":"gtm-script","innerHTML":"!function(){\"use strict\";function l(e){for(var t=e,r=0,n=document.cookie.split(\";\");r<n.length;r++){var o=n[r].split(\"=\");if(o[0].trim()===t)return o[1]}}function s(e){return localStorage.getItem(e)}function u(e){return window[e]}function A(e,t){e=document.querySelector(e);return t?null==e?void 0:e.getAttribute(t):null==e?void 0:e.textContent}var e=window,t=document,r=\"script\",n=\"dataLayer\",o=\"https://gtm.onthatass.com\",a=\"\",i=\"8sgytmxskyzux\",c=\"8t=aWQ9R1RNLU45Njg1Rw%3D%3D&apiKey=9ca3fd1e\",g=\"stapeUserId\",v=\"\",E=\"\",d=!1;try{var d=!!g&&(m=navigator.userAgent,!!(m=new RegExp(\"Version/([0-9._]+)(.*Mobile)?.*Safari.*\").exec(m)))&&16.4<=parseFloat(m[1]),f=\"stapeUserId\"===g,I=d&&!f?function(e,t,r){void 0===t&&(t=\"\");var n={cookie:l,localStorage:s,jsVariable:u,cssSelector:A},t=Array.isArray(t)?t:[t];if(e&&n[e])for(var o=n[e],a=0,i=t;a<i.length;a++){var c=i[a],c=r?o(c,r):o(c);if(c)return c}else console.warn(\"invalid uid source\",e)}(g,v,E):void 0;d=d&&(!!I||f)}catch(e){console.error(e)}var m=e,g=(m[n]=m[n]||[],m[n].push({\"gtm.start\":(new Date).getTime(),event:\"gtm.js\"}),t.getElementsByTagName(r)[0]),v=I?\"&bi=\"+encodeURIComponent(I):\"\",E=t.createElement(r),f=(d&&(i=8<i.length?i.replace(/([a-z]{8}$)/,\"kp$1\"):\"kp\"+i),!d&&a?a:o);E.async=!0,E.src=f+\"/\"+i+\".js?\"+c+v,null!=(e=g.parentNode)&&e.insertBefore(E,g)}();","type":"text/javascript","crossorigin":"anonymous"}],"noscript":[{"id":"gtm-noscript","innerHTML":"<iframe src=\"https://gtm.onthatass.com/ns.html?id=GTM-N9685G\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>","tagPriority":"low"}],"title":"ON THAT ASS"}

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false